exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-pages-cms-page-template-index-js": () => import("./../../../src/templates/pages/CmsPageTemplate/index.js" /* webpackChunkName: "component---src-templates-pages-cms-page-template-index-js" */),
  "component---src-templates-pages-project-page-template-index-js": () => import("./../../../src/templates/pages/ProjectPageTemplate/index.js" /* webpackChunkName: "component---src-templates-pages-project-page-template-index-js" */)
}

